<div class="title">
  <mat-icon>category</mat-icon>
  Content Type
</div>
<div class="description">SELECT THE CONTENT TYPES TO FILTER BY</div>

<div class="options">
  <elements-filter-chip
    icon="category"
    [caption]="product.name"
    [selected]="isSelected(product)"
    *ngFor="let product of products$ | async"
    (click)="isSelected(product) ? removeProduct(product) : addProduct(product)"
    [suffixIcon]="isSelected(product) ? 'close' : undefined"
  >
  </elements-filter-chip>
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
